import { SonicWorkInputData } from "./SonicWorkInputData";

export const parseAndValidWorks = (
  update_args: {
    [key: string]: string | File;
  },
  workItems: Array<SonicWorkInputData>
) => {
  if (workItems.length > 0) {
    const uploadWorkImgs: Array<File> = [];
    const updateObj: Array<Omit<SonicWorkInputData, "error">> = [];
    const imgsMeta: Array<string> = [];

    workItems.forEach((el, i) => {
      if (el.error == true || !el.title) {
        return false;
      } else {
        updateObj.push({
          title: el.title,
          description: el.description,
          link: el.link,
        });
        if (el.image) {
          if (el.image instanceof File) {
            uploadWorkImgs.push(el.image);
            updateObj[i].image = el.image;
            imgsMeta.push("new");
          } else {
            imgsMeta.push(el.image.id.toString());
          }
        } else {
          imgsMeta.push("");
        }
      }
    });

    if (updateObj.length === 0) {
      return true;
    }

    if (uploadWorkImgs.length !== 0) {
      uploadWorkImgs.forEach((img, i) => {
        if (img instanceof File) {
          update_args[`sonic_work_imgs${i}`] = img;
        } else {
          update_args[`sonic_work_imgs${i}`] = "";
        }
      });
    }

    update_args["sonic_imgs_meta"] = JSON.stringify(imgsMeta);
    update_args["sonic_works"] = JSON.stringify(updateObj);
    return true;
  } else {
    update_args["sonic_works"] = JSON.stringify([]);
    return true;
  }
};
